export default __webpack_public_path__ + "static/media/no_image_exist.16da9f4d.png";